import { render, staticRenderFns } from "./creditApprove.vue?vue&type=template&id=82020248&scoped=true"
import script from "./creditApprove.vue?vue&type=script&lang=js"
export * from "./creditApprove.vue?vue&type=script&lang=js"
import style0 from "./creditApprove.vue?vue&type=style&index=0&id=82020248&prod&scoped=scoped&lang=scss"
import style1 from "./creditApprove.vue?vue&type=style&index=1&id=82020248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82020248",
  null
  
)

export default component.exports